import { render, staticRenderFns } from "./poll-view.vue?vue&type=template&id=72ec9862&scoped=true"
import script from "./poll-view.vue?vue&type=script&lang=js"
export * from "./poll-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec9862",
  null
  
)

export default component.exports